import React, { useState } from 'react'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import Divider from '@vtex/styleguide/lib/Divider'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'
import Toggle from '@vtex/styleguide/lib/Toggle'
import Textarea from '@vtex/styleguide/lib/Textarea'

type SharableLinkCreatorProps = {
  message: string
  vendorCode: string
  setIsLinkReady: (isLinkReady: boolean) => void
  setMessage: (message: string) => void
}

export const SharableLinkCreator = ({
  message,
  vendorCode,
  setMessage,
  setIsLinkReady,
}: SharableLinkCreatorProps) => {
  const [openMessage, setOpenMessage] = useState(false)

  return (
    <div data-testId="sharePaymentMountShow">
      <ModalTitle id="socialSharePaymentLabel" />
      <Divider orientation="horizontal" />
      <div className="pv6 flex flex-column ">
        <div className="c-on-base mb3">
          <FormattedMessage id={'socialSharePaymentContent'} />
          {vendorCode ? (
            <span className="t-small">{`  ${vendorCode}`}</span>
          ) : null}
        </div>
        <span className="c-on-base  ">
          <FormattedMessage id={'socialShareMoreInfo'} />
        </span>

        <div className="mv3">
          <Toggle
            testId="toggle-message"
            label={<FormattedMessage id={'socialShareMessageDetail'} />}
            checked={openMessage}
            onChange={() => setOpenMessage((prev) => !prev)}
          />
        </div>

        {openMessage ? (
          <div className="mv2">
            <Textarea
              dataAttributes={{ testid: 'share-text-area' }}
              label="Message"
              value={message}
              onChange={(ev: React.ChangeEvent<HTMLInputElement>) =>
                setMessage(ev.target.value)
              }
            />
          </div>
        ) : null}
      </div>

      <Button
        testId="generate-link-button"
        variation="primary"
        onClick={() => setIsLinkReady(true)}
        block
      >
        <FormattedMessage id={'socialShareGenerateLink'} />
      </Button>
    </div>
  )
}
